<mdb-card cascade="true" narrower="true" [@fadeInOnEnter] >
    <div>
      <div class="special-color text-white d-flex justify-content-center p-3">
        <h5><i class="fa fa-search mr-1"></i>Search Asset</h5>
      </div>

      <div class="row m-2">

        <div class="col-md-6">
          <mdb-card class="w-100 p-2">
              <mdb-card-header class="k-hbox">
                <div>
                  <h1 kendoCardTitle>Asset</h1>
                  <p kendoCardSubtitle>Filter by Fields</p>
                </div>
              </mdb-card-header>
  
              <kendo-floatinglabel text="Make" class="w-100">
                <input kendoTextBox [(ngModel)]="make" class="w-100" (input)="refreshData()"/>
              </kendo-floatinglabel>
              <kendo-floatinglabel text="Model" class="w-100">
                <input kendoTextBox [(ngModel)]="model" class="w-100" (input)="refreshData()" />
              </kendo-floatinglabel>
              <kendo-floatinglabel text="Description" class="w-100">
                <input kendoTextBox [(ngModel)]="description" class="w-100" (input)="refreshData()" />
              </kendo-floatinglabel>
              <kendo-floatinglabel text="Component Type" class="w-100">
                <kendo-combobox
                  [(ngModel)]="componentType"
                  class="w-100"
                  [data]="dataComponentTypes"
                  [textField]="'description'"
                  [valueField]="'typeCode'"
                  [valuePrimitive]="true"
                  [allowCustom]="true"
                  (valueChange)="handleFilterComponentType()">
                  <ng-template kendoDropDownListItemTemplate let-dataItem> {{ dataItem.description }} - {{ dataItem.typeCode }} </ng-template>
                </kendo-combobox>
            </kendo-floatinglabel>
            <kendo-floatinglabel text="Barcode" class="w-100">
              <input kendoTextBox [(ngModel)]="assetBarCode" class="w-100" (input)="refreshData()"/>
            </kendo-floatinglabel>
        
            <kendo-floatinglabel text="Functional Location 1" class="w-100">
              <kendo-combobox 
                  [valuePrimitive]="true" 
                  [(ngModel)]="functionalLocation1"
                  [data]="fl1" 
                  class="w-100" 
                  [allowCustom]="true"
                  (valueChange)="handleFilterFuncLoc1()">
              </kendo-combobox>
            </kendo-floatinglabel>

            <kendo-floatinglabel text="Functional Location 2" class="w-100">
              <kendo-combobox 
                [valuePrimitive]="true" 
                [(ngModel)]="functionalLocation2"
                [data]="fl2" 
                class="w-100" 
                [allowCustom]="true"
                (valueChange)="handleFilterFuncLoc2()">
              </kendo-combobox>
            </kendo-floatinglabel>

            <kendo-floatinglabel text="Functional Location 3" class="w-100">
              <kendo-combobox 
                  [valuePrimitive]="true" 
                  [(ngModel)]="functionalLocation3"
                  [data]="fl3" 
                  class="w-100" 
                  [allowCustom]="true"
                  (valueChange)="handleFilterFuncLoc3()">
              </kendo-combobox>
            </kendo-floatinglabel>

          </mdb-card>
        </div>

        <div class="col-md-6">
          <mdb-card class="w-100 p-2">
             <mdb-card-header class="k-hbox">
                <div>
                   <h1 kendoCardTitle>Dimension</h1>
                   <p kendoCardSubtitle>Filter by Dimensions</p>
                </div>
             </mdb-card-header>
             <div *ngFor="let dim of dataDimensions; let i = index">
                <div>
                   <kendo-floatinglabel [text]="dim.dimensionDescription" class="w-100">
                      <kendo-combobox
                         [valuePrimitive]="true"
                         [data]="dim.dimensionDataList"
                         [textField]="'description'"
                         [valueField]="'id'"
                         class="w-100"
                         [allowCustom]="true"
                         (valueChange)="handleDimChange($event, dim.dimensionDescription)"
                      >
                      </kendo-combobox>
                   </kendo-floatinglabel>
                </div>
             </div>
          </mdb-card>
        </div>
      </div>

      <div class="special-color text-white d-flex justify-content-center p-3">
        <mdb-spinner *ngIf="loadingAssets" spinnerType="small"></mdb-spinner>
      </div>
      <div *ngIf="!loadingAssets">
        
        <mdb-card>
          <button
            title="Select"
            (click)="selectAssets()"
            kendoButton
            [icon]="'check-circle'"
            class="ml-1"
          >Add All</button>
        </mdb-card>
      </div>
      
      <kendo-grid #grid
        class="mb-3"
        [selectable]="{ checkboxOnly: false }"
        [pageSize]="10"
        [pageable]="false"
        [sortable]="true"
        [scrollable]="'none'"
        name="Asset"
        [appAMSBindingSearchAsset]="'AssetSearch'"
      >
        <kendo-grid-column
               [columnMenu]="false"
               [filterable]="false"
               [groupable]="false"
               [reorderable]="false"
               [resizable]="false"
               [sortable]="false"
               [width]="60"
               field="assetCode"
               title=""
               [headerClass]="'grid-header'"
            >
               <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <div class="d-flex" kendoTooltip tooltipClass="tooltip-ams">
                     <button
                        title="Select"
                        (click)="selectAsset($event, dataItem)"
                        kendoButton
                        [icon]="'check-circle'"
                        class="ml-1"
                     >Add</button>
                    
                  </div>
               </ng-template>
            </kendo-grid-column>

            <kendo-grid-column media="md" class="no-padding" title="Asset Barcode" field="assetBarcode" filter="text">
              <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="text-wrap">{{ dataItem.assetBarcode }}</div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column media="md" class="no-padding" title="Photo" field="description" filter="text">
              <ng-template kendoGridCellTemplate let-dataItem>
                    <img style="height: 50px; width: 50px;" src="{{ dataItem.photo ? baseUrl + 'asset/photo/' + dataItem.assetCode + '/1' : '../assets/img/monitor_computer.jpg' }}" class="img-fluid z-depth-2" alt="avatar" />
              </ng-template>
            </kendo-grid-column>
  
            <kendo-grid-column media="md" class="no-padding" title="Description" field="description" filter="text">
              <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="text-wrap">{{ dataItem.description }}</div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column media="md" class="no-padding" title="Room Code" field="room" filter="text">
              <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="text-wrap">{{ dataItem.room }}</div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column media="md" class="no-padding" title="Make" field="make" filter="text">
              <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="text-wrap">{{ dataItem.make }}</div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column media="md" class="no-padding" title="Model" field="model" filter="text">
              <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="text-wrap">{{ dataItem.model }}</div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column media="md" class="no-padding" title="Serial Number" field="serialNumber" filter="text">
              <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="text-wrap">{{ dataItem.serialNumber }}</div>
              </ng-template>
            </kendo-grid-column>

      </kendo-grid>
    </div>
  </mdb-card>
  